import { render, staticRenderFns } from "./BaseSignature.vue?vue&type=template&id=644da928&scoped=true"
import script from "./BaseSignature.vue?vue&type=script&lang=js"
export * from "./BaseSignature.vue?vue&type=script&lang=js"
import style0 from "./BaseSignature.vue?vue&type=style&index=0&id=644da928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644da928",
  null
  
)

export default component.exports